import type { ListBuilderList } from '../../../types';

/**
 * Missing Files list - licenses that have no attached files.
 *
 * Compliance reviewers use this to triage licenses that are missing
 * supporting documentation. The licenseHasFiles filter is locked to "no"
 * so the queue can't be accidentally widened.
 */
export const missingFilesList: ListBuilderList = {
	id: 'default-licenses-missing-files',
	cacheTTL: 300000,
	name: 'Missing Files',
	type: 'default',
	active: true,
	sortOrder: 5,
	filterRules: {
		licenseHasFiles: {
			defaultValue: { id: 'no', label: 'No' },
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	inheritsFrom: 'default-licenses-all',
};
